import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { Grid } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { Header, Footer } from "~/components/blocks";
import { Margin, Breadcrumb, Title, Text, Button } from "~/components/elements";
import { HeroBanner } from "~/components/sections";
import { useLocation } from "react-router-dom";
import * as S from "./styles";
import { scrollTop } from "~/utils/tools";
import isMobile from "~/hooks/isMobile";
import history from "~/routes/history";

export default function Error404() {
  const mobile = isMobile();
  const location = useLocation();
  const transition = {
    duration: 0.3,
    ease: [0.43, 0.13, 0.23, 0.96],
  };
  

  const navBreadcrumb = [
    {
      text: "Início",
      link: "/",
    },                          
    {
      text: "Página não encontrada",
      link: "/erro-404",
    },
  ];

  const animations = {
    exit: { y: "50%", opacity: 0, transition },
    enter: {
      y: "0%",
      opacity: 1,
      transition,
    },
  };

  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <>
      <Helmet>
        <title>Página não encontrada</title>
      </Helmet>

      <Header />

      <HeroBanner />

      <Breadcrumb navBreadcrumb={navBreadcrumb} />

      <S.StyledMotionDiv>
        <div className="div" style={{backgroundColor: "#F5F5F5"}} >
          <motion.div
            variants={animations}
            className="single"
            initial="exit"
            animate="enter"
            exit="exit"
          >
            <Margin>
              <Grid
                container
                justifyContent="space-between"
                align={mobile ? "center" : "initial"}
              >
                <S.PageHolder>
                    <S.TitleHolder>
                      <Title
                        as="1"
                        levelDesktop="4"
                        level="4"
                        primary={false}
                      >
                        <strong>
                          Página não encontrada
                        </strong>
                      </Title>
                    </S.TitleHolder>
                    <Text level="2">ERRO 404</Text>
                    <S.ButtonHolder>
                      <Button
                        color="primary"
                        onClick={() =>
                          history.push({
                            pathname: "/",
                            search: location.search,
                          })
                        }
                        id="homeButton404"
                      >
                        VOLTAR PARA HOME
                      </Button>
                    </S.ButtonHolder>
                </S.PageHolder>
              </Grid>
            </Margin>
          </motion.div>
        </div>
      </S.StyledMotionDiv>

      <Footer />
    </>
  );
}
